import $http from "./http";

// 权限菜单
export const authority = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/authority" + id : "/v1/authority",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

//配置信息公共接口
export const gconf = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/config/gconf/" + id : "/v1/config/gconf",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 工单
export const work = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/work/" + id : "/v1/work",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};
export const init = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/work/init/" + id : "/v1/work/init",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 角色
export const role = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/role/" + id : "/v1/role",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 角色下拉
export const roleSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/role/select/" + id : "/v1/role/select",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 权限列表
export const menu = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/menu/" + id : "/v1/menu",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 设置菜单状态
export const menuSetStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/menu/set-status/" + id : "/v1/menu/set-status",
        method == "get" ? {
            params: params
        } : params
    );
};

// 获取菜单设置状态
export const menuGetStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/menu/get-status/" + id : "/v1/menu/get-status",
        method == "get" ? {
            params: params
        } : params
    );
};

// 菜单状态下拉
export const menuSelectStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/menu/select-status/" + id : "/v1/menu/select-status",
        method == "get" ? {
            params: params
        } : params
    );
};

// 菜单功能权限
export const getMenuAuth = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/menu/get-menu-auth/" + id : "/v1/menu/get-menu-auth",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 修改密码
export const changePwd = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/system/change-pwd/" + id : "/v1/system/change-pwd",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};
export const changeUserPwd = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/change-pwd/" + id : "/v1/user/change-pwd",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 工单操作
export const process = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/work/process/" + id : "/v1/work/process",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 工单变更历史
export const history = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/work/history/" + id : "/v1/work/history",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 员工导入
export const userImport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/import/" + id : "/v1/user/import",
        method == "get" ?
        {
            params: params
        } :
        params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
};

// 员工
export const user = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/" + id : "/v1/user",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 教育背景
export const school = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/school/" + id : "/v1/school",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 健康状况
export const health = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/health/" + id : "/v1/health",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 获取员工列表
export const select = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/select/" + id : "/v1/user/select",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 下载模板
export const downloadTpl = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/download-tpl/" + id : "/v1/user/download-tpl",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 通知消息
export const notice = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/notice/" + id : "/v1/notice",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 通知消息数量
export const noticeTotal = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/notice/total/" + id : "/v1/notice/total",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 消息弹出列表
export const noticeTips = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/notice/tips/" + id : "/v1/notice/tips",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 消息列表按钮显示
export const noticeRead = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/notice/read/" + id : "/v1/notice/read",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 人事统计
export const userStatistics = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user-statistics/" + id : "/v1/user-statistics",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 考勤列表
export const attendance = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/attendance/" + id : "/v1/attendance",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 考勤报告
export const attendanceReport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/attendance-report/" + id : "/v1/attendance-report",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 考勤报告
export const attendanceDetail = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/attendance-detail/" + id : "/v1/attendance-detail",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 确认考勤
export const attendanceConfirm = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/attendance/confirm/" + id : "/v1/attendance/confirm",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 处理考勤
export const attendanceFinish = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/attendance/finish/" + id : "/v1/attendance/finish",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 获取待确认考勤列表
export const attendanceTobeConfirmed = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/profile/attendance-tobe-confirmed/" + id :
        "/v1/profile/attendance-tobe-confirmed",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 确认考勤
export const repairAttendance = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/profile/repair-attendance/" + id :
        "/v1/profile/repair-attendance",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 获取待审核考勤列表
export const pendingAttendance = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/profile/pending-attendance/" + id :
        "/v1/profile/pending-attendance",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 审核考勤
export const auditAttendance = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/profile/audit-attendance/" + id :
        "/v1/profile/audit-attendance",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 我的考勤
export const profileAttendance = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/profile/attendance/" + id : "/v1/profile/attendance",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 导出考勤报告
export const attendanceReportExport = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/attendance-report/export/" + id :
        "/v1/attendance-report/export",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 导出考勤报告
export const attendanceDetailExport = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/attendance-detail/export/" + id :
        "/v1/attendance-detail/export",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 导出员工
export const userExport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/export/" + id : "/v1/user/export",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

//工单导出
export const workOrderExport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/work-orders/export/" + id : "/v1/work-orders/export",
        method == "get" ?
            {
                params: params
            } :
            params
    );
};

// 设置角色
export const userSetRole = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/set-role/" + id : "/v1/user/set-role",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 人事设置
export const configSetting = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/config/setting/" + id : "/v1/config/setting",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 添加银行信息
export const addBank = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/add-bank/" + id : "/v1/user/add-bank",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 资产管理
export const commodity = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/commodity/" + id : "/v1/commodity",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 资产管理 -- 导入
export const commodityImport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/commodity/import/" + id : "/v1/commodity/import",
        method == "get" ?
        {
            params: params
        } :
        params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
};

// 资产管理 物品管理 批量导出
export const commodityExport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/commodity/export/" + id : "/v1/commodity/export",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 招聘管理 面试列表
export const interview = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/interview/" + id : "/v1/interview",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 招聘管理 面试列表 批量导出
export const interviewBatchExport = data =>
    $http.get("/v1/interview/export", data);

// 招聘管理 面试列表 批量导入
export const interviewBatchImport = (params, method, id) => {
    return $http[`${method}`]("/v1/interview/import", params, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

// 招聘管理 面试列表 状态修改
export const interviewUpdateStatus = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/interview/update-status/" + id :
        "/v1/interview/update-status",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 招聘管理 招聘列表 状态修改
export const recruitmentUpdateStatus = (params, method, id) => {
    return $http[`${method}`](
        id ?
        "/v1/recruitment/update-status/" + id :
        "/v1/recruitment/update-status",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 招聘测试 -- 通过
export const interviewChecked = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/interview/checked/" + id : "/v1/interview/checked",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 预警信息
export const itemWarn = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/item-warn/" + id : "/v1/item-warn",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 待转正员工列表
export const probation = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/probation/" + id : "/v1/probation",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 版本发布列表
export const versions = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/publish-log/" + id : "/v1/publish-log",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};
// 获取最新版本
export const lastversions = (params, method) => {
    return $http[`${method}`](
        "/v1/publish-log/last-version",
        {
            params: params
        }
    );
};

// 招聘列表列表
export const recruitment = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/recruitment/" + id : "/v1/recruitment",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 招聘列表列表
export const recruitmentRecruit = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/recruitment/recruit/" + id : "/v1/recruitment/recruit",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 导出招聘
export const recruitmentExport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/recruitment/export/" + id : "/v1/recruitment/export",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 导入招聘
export const recruitmentImport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/recruitment/import/" + id : "/v1/recruitment/import",
        method == "get" ?
        {
            params: params
        } :
        params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
};

// 活动管理 活动列表
export const activityList = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/events/" + id : "/v1/events",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 活动管理 批量删除活动计划
export const eventsBatchDelete = data => {
    return $http.post("/v1/events/batch-delete", data);
};

// 活动管理 活动列表 状态的修改
export const eventsUpdateStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/events/update-status/" + id : "/v1/events/update-status",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 活动管理 活动列表 编辑活动回顾
/* export const eventsEditReview = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/events/add-review' + id : '/v1/events/add-review',
        method == 'get' ? {
            params: params
        } : params
    );
}; */

// 活动管理 活动列表 查看活动回顾
export const eventsReview = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/events/event-review/" + id : "/v1/events/event-review",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 活动管理 活动列表 报名信息列表
export const eventsSignupList = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/events-detail/" + id : "/v1/events-detail",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 协同办公 项目列表
export const project = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/project/" + id : "/v1/project",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 协同办公 项目列表 下拉
export const projectSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/project/select/" + id : "/v1/project/select",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 协同办公 任务管理 任务状态修改
export const projectUpdateStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/project/update-status/" + id : "/v1/project/update-status",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 协同办公 任务列表
export const job = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/job/" + id : "/v1/job",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 协同办公 任务管理 任务备注
export const jobComment = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/job/job-comment/" + id : "/v1/job/job-comment",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 协同办公 任务管理 项目团队
export const projectTeam = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/project/team/" + id : "/v1/project/team",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 协同办公 任务管理 任务状态修改
export const jobUpdateStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/job/update-status/" + id : "/v1/job/update-status",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 首页 我的任务
export const myjob = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/job/my-job/" + id : "/v1/job/my-job",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 首页 任务走势统计
export const jobStatistics = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/job/statistics/" + id : "/v1/job/statistics",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 任务管理 开始 or 完成 任务
export const jobDetail = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/job/detail/" + id : "/v1/job/detail",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 任务管理 完成 指派人总耗时
export const jobDetailTotalTime = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/job/detail-total-time/" + id : "/v1/job/detail-total-time",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 项目管理 汇报数据
export const projectReport = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/project/report/" + id : "/v1/project/report",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 项目管理 汇报
export const projectMilestone = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/project/milestone/" + id : "/v1/project/milestone",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 会议记录
export const meetingList = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/meeting/" + id : "/v1/meeting",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 会议记录 状态修改
export const meetingUpdateStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/meeting/update-status/" + id : "/v1/meeting/update-status",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 会议记录 参加会议 
export const meetingAccept = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/meeting/accept/" + id : "/v1/meeting/accept",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 会议记录 总结 
export const meetingSummary = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/meeting/summary/" + id : "/v1/meeting/summary",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 会议记录 会议室下拉菜单 
export const meetingSelectRoom = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/meeting/select-room/" + id : "/v1/meeting/select-room",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 会议记录 开始预约时间 
export const meetingStartAvailableTime = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/meeting/start-available-time/" + id : "/v1/meeting/start-available-time",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 会议记录 预约结束时间 
export const meetingEndAvailableTime = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/meeting/end-available-time/" + id : "/v1/meeting/end-available-time",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 组织架构人员
export const departUser = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/depart/user/' + id : '/v1/depart/user',
        method == 'get' ? {
            params: params
        } : params
    );
};

// 会议室设置 列表 
export const meetingRoom = (params, method, id) => {
    return $http[`${method}`](
        id ? `/v1/meeting/room?${params}=${id}` : '/v1/meeting/room',
        method == 'get' ? {
            params: params
        } : params
    );
};

// 会议室设置 会议详情 
export const meetingLookUp = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/meeting/look-up/' + id : '/v1/meeting/look-up',
        method == 'get' ? {
            params: params
        } : params
    );
};

// 会议室设置 查看单个 
export const meetingLookUpRoom = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/meeting/look-up-room/' + id : '/v1/meeting/look-up-room',
        method == 'get' ? {
            params: params
        } : params
    );
};

// 选择部门返回对应人员
export const getDepartSelectUser = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/depart/select-user/' + id : '/v1/depart/select-user',
        method == 'get' ? {
            params: params
        } : params
    );
};

// 工单管理 
export const workOrdersList = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/work-orders/" + id : "/v1/work-orders",
        method == "get" ?
        {
            params: params
        } :
        params
    );
};

// 工单管理 状态修改
export const workOrdersUpdateStatus = (params, method, id) => {
    return $http[`${method}`](
        "/v1/work-orders/update-status", params
    );
};

// 工单管理 确认 
export const workOrdersConfirm = (params, method, id) => {
    return $http[`${method}`](
        "/v1/work-orders/confirmed", params
    );
};

// 工单管理 排序
export const workOrdersSort = (params, method, id) => {
    return $http[`${method}`](
        "/v1/work-orders/update-sort", params
    );
};

// 工单管理 工单完成率
export const workOrdersCompletion = (params, method, id) => {
    return $http[`${method}`](
        "/v1/work-orders/statistics", {params}
    );
};
//生成工单周统计
export const buildWorkorderStat = (params, method, id) => {
    return $http[`${method}`](
        "/v1/work-orders/build-stat", {params}
    );
};

//工单日志
export const workOrderShowLogList = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/work-orders/get-work-orders-log?work_orders_id=" + id : "/v1/work-orders/get-work-orders-log",
        method == "get" ?
            {
                params: params
            } :
            params
    );
};

// 工单管理 状态修改
export const workOrdersPostRemark = (params, method) => {
    return $http[`${method}`](
        "/v1/work-orders/comment", params
    );
};

/**
 * 获取所有学历列表
 * @param params
 * @param method
 * @param id
 * @returns {*}
 */
export const educationSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/user/init/" + id : "/v1/user/init",
        method == "get" ?
            {
                params: params
            } :
            params
    );
};

/**
 * 获取转证日期
 * @param params
 * @param method
 * @param id
 * @returns {*}
 */
export const getEffectDate = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/config/gconf/" + id : "/v1/config/gconf",
        method == "get" ?
            {
                params: params
            } :
            params
    );
};

// 工单bug跟踪 
export const workOrdersTrackList = (params, method = 'get') => {
    return $http[`${method}`](
        "/v1/work-orders/track-list",
        method == "get" ? {
            params: params
        } :
        params
    );
};

// 工单bug跟踪状态 
export const workOrdersSetTrackStatus = (params, method) => {
    return $http[`${method}`](
        "/v1/work-orders/set-track-status",
        method == "get" ? {
            params: params
        } :
        params
    );
};

// 删除工单bug跟踪 
export const workOrdersRemoveTrack = (id, method) => {
    return $http[`${method}`](
        "/v1/work-orders/remove-track?id=" + id
    );
};

// 创建工单bug跟踪 
export const workOrdersCreateTrack = (params, method) => {
    return $http[`${method}`](
        "/v1/work-orders/create-track",
        method == "get" ? {
            params: params
        } :
        params
    );
};